<script lang="ts">
    import cn from 'classnames';

    import { Font, FontTypes } from '@uikit/font';
    import { SvgIcon } from '@uikit/svg-icon';

    import type { IconListItem } from './types';

    import s from './icon-list.module.css';

    export let items: IconListItem[];
</script>

<ul class={s.list}>
    {#each items as item}
        <li class={cn(s.listItem, item.classes)}>
            {#if item.icon}
                <span class={s.listItemIcon}>
                    <SvgIcon icon={item.icon} />
                </span>
            {/if}
            <Font
                    className={s.listItemText}
                    tagName={FontTypes.TagName.p}
                    type={FontTypes.Type.body}
            >
                {item.text}
            </Font>
        </li>
    {/each}
</ul>
